module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAOCAYAAADNGCeJAAAAuklEQVQ4T7WTTQ4BQRSEvzoCOyw4AOECnIMda+extuQcXIBwABbGjiOUZNKSyZjJ/KCXr/t9r6o6T7bnwJrvz0K2DbQl3evybLeAKIZJUl3Quy/mJGFBZSSpUwS3fQuOYiEfsFA8AENgJmmbhtqeAhvgKGmUqyxx0QdOwFNSM1F/AA1gIOmcHJSpLPVgB4yBFbAE9pImWREUwoLtLnABepKueVmWghV9RGFmZQGVMqsC/Y/NX67Tzxb9BQr2kpnuEbVZAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/email.png
// module id = vCvB
// module chunks = 3